/* eslint-disable react/jsx-pascal-case */
// src/App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layouts/Layout';
import Home from './Pages/Home/Home';
import Intern from './Pages/Home/Intern';
import Login from './Pages/Login/Login';
import Register from './Pages/Login/Register';
import ResetPassword from './Pages/Login/ResetPassword';
import Admin from './Pages/Admin/Admin';
import UserAdmin from './Pages/Admin/UserAdmin/UserAdmin';

import Team2 from './Pages/Admin/Forms/CreateTransportArrival';
import Meeting from "./Pages/Admin/Forms/Create_Meeting";
import Practice from "./Pages/Admin/Practice/Create_Practice";
import Transport from "./Pages/Admin/Forms/TransportSide";
import FormTransportArrivalCreate from "./Pages/Admin/Forms/CreateTransportArrival";
import FormTransportDepartureCreate from "./Pages/Admin/Forms/CreateTransportDeparture";
import FormTransportLokalCreate from "./Pages/Admin/Forms/CreateTransportLokal";
import Transport_ArrivalListe from "./Pages/Admin/Forms/Transport_ArrivalListe";
import MediaDashboard from './Pages/Media/MediaDashboard';
import TeamDashboard from './Pages/Admin/Team/TeamDashboard';
import ClubDashboard from './Pages/Admin/Club/ClubDashboard';
import ChampDashboard from './Pages/Admin/Champ/ChampDashboard';
import TransportDashboard from './Pages/Admin/Transport/TransportDashboard';
import EventPage from './Pages/Tilmeld/EventPage';
import Persons from './Pages/Admin/ID/Persons';
import IDCardDesignerPage from './Pages/Admin/ID/IDCardDesignerPage';
import AdminEvent from './Pages/Admin/Event/AdminEvent';
import EventMenuPage from './Pages/Admin/Event/EventMenuPage';
import DrinksMenuPage from './Pages/Admin/Drinks/DrinksMenuPage';
import ZonesPage from './Pages/Admin/Zones/ZonesPage';
import UserDashboard from './Pages/Profil/UserDashboard';
import PrivateRoute from './components/PrivateRoute';
import CreateQRCode from "./Pages/Plugins/Parking/CreateQRCode";
import QRCodeList from "./Pages/Plugins/Parking/QRCodeList";
import QRScanner from "./Pages/Plugins/Parking/QRScanner";
import RoleSelect from "./Pages/Login/RoleSelect";
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import Unauthorized from "./Pages/Unauthorized/Unauthorized";
import EventListPage from "./Pages/Tilmeld/EventListPage";
import { LanguageProvider } from "./context/LanguageContext";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import VisaPage from './Pages/Admin/Visa/VisaPage';     
import VisaPageFront from './Pages/Visa/VisaPageFront';
import ShiftsPage from './Pages/Admin/Shifts/ShiftsPage';
import EventFilesAdminPage from "./Pages/Admin/Filesystem/EventFilesAdminPage";
import EventFilesViewPage from "./Pages/Admin/Filesystem/EventFilesViewPage";
import EventPersonOversigt from "./Pages/EventPersonOversigt/EventPersonOversigt";
import TicketDashBoard from "./Pages/Admin/Ticket/TicketsBoardPage"
import TransportBookingPage from "./Pages/Transport/TransportBookingPage";
import ExperienceBookingPage from "./Pages/Experience/ExperienceBookingPage";
import AdminMessagePage from "./Pages/Admin/GruppeBeskeder/AdminMessagePage";
import FriviligePage from "./Pages/Admin/FriviligeListe/FriviligePage";
import TransportAdminPageSettings from "./Pages/Admin/Transport/Settings/TransportSetupPage";
import TransportAdminPageDaily from "./Pages/Admin/Transport/Daily/TransportAdminPage";
import ExperienceAdminPage from "./Pages/Admin/Experience/ExperienceAdminPage";
import TransportRequestOverview from "./Pages/Transport/TransportRequestOverview";
import TeamPerson from "./Pages/Team/TeamPerson";
import TransportArrivalRequestPage from "./Pages/Transport/TransportArrivalRequestPage";
import TransportDepartureRequestPage from "./Pages/Transport/TransportDepartureRequestPage";
import MediaAdminPage from "./Pages/Admin/Media/MediaAdminPage";
import AdminTransportBookings from "./Pages/Admin/Transport/StartEnd/AdminTransportBookings";
import TransportRouteAdminPage from "./Pages/TransportRoute/TransportRouteAdminPage";
import TransportRouteDashboard from "./Pages/Admin/Transport/TransportRoute";
import AllAvailableShiftListPublic from "./Pages/Tilmeld/AllAvailableShiftListPublic"

import TransportLocalRequestPage from "./Pages/Transport/TransportLocalRequestPage";
// Drinks – Bar
import FormDrinkOrder from "./Pages/Drinks/FormDrinkOrder";

// Drinks – Admin
import AdminDrinkFunctionAllowance from "./Pages/Drinks/AdminDrinkFunctionAllowance";
import AdminDrinkPersonAllowance from "./Pages/Drinks/AdminDrinkPersonAllowance";
//import AdminPersonExtraDrinks from "./Pages/Drinks/FormDrinkOrder";
import AdminDrinkOverview from "./Pages/Drinks/AdminDrinkOverview";
import AdminDrinkTicketCollections from "./Pages/Drinks/AdminDrinkTicketCollections";
import DrinkTicketOrder from "./Pages/Drinks/DrinkTicketOrder";
import AdminDrinkTicketPrint from "./Pages/Drinks/AdminDrinkTicketPrint";
import AdminDrinkAssignedPersons from "./Pages/Drinks/AdminDrinkAssignedPersons";


import Form_Practice from "./Pages/Admin/Practice/Create_Practice";
import TransportMyBookings from "./Pages/Transport/TransportMyBookings"
import MeeetingAdminPage from "./Pages/Admin/Meeting/MeetingAdminPage";
import WhatsAppAdmin from "./Pages/Admin/WhatsApp/WhatsAppAdmin";

import TransportRouteBookingPage from "./Pages/TransportRoute/TransportRouteBookingPage";
import TransportRouteBookingsAdminPage from "./Pages/TransportRoute/TransportRouteBookingsAdminPage";
import TransportVIP from "./Pages/Admin/Parking/ParkingPerson";
import ParkingValidationPage from "./Pages/Admin/Parking/ParkingValidationPage";


const App: React.FC = () => {

    // Track logged-in user globally
    const [currentUser, setCurrentUser] = useState({
        token: sessionStorage.getItem("authToken"),
        userId: sessionStorage.getItem("userId"),
        email: sessionStorage.getItem("email"),
        firstName: sessionStorage.getItem("firstName"),
        lastName: sessionStorage.getItem("lastName"),
        personId: sessionStorage.getItem("personId"),
    });

    useEffect(() => {
        const handleAuthChange = () => {
            setCurrentUser({
                token: sessionStorage.getItem("authToken"),
                userId: sessionStorage.getItem("userId"),
                email: sessionStorage.getItem("email"),
                firstName: sessionStorage.getItem("firstName"),
                lastName: sessionStorage.getItem("lastName"),
                personId: sessionStorage.getItem("personId"),
            });
        };

        window.addEventListener("auth-changed", handleAuthChange);
        return () => window.removeEventListener("auth-changed", handleAuthChange);
    }, []);

    return (
        <MantineProvider>
            <Notifications />
            <LanguageProvider>
                <Router basename="/">
                    <Routes>
                        <Route path="unauthorized" element={<Unauthorized />} />
                        <Route path="/epos/:personId/:eventId" element={<EventPersonOversigt />} />
                        <Route path="/" element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/intern" element={<Intern />} />
                            <Route path="/team" element={<EventListPage entry="team" title="Team events" />} />
                            <Route path="/media" element={<EventListPage entry="media" title="Media events" />} />
                            <Route path="/intern" element={<EventListPage entry="intern" title="Interne events" />} />



                            {/*<Route index element={<Home />} />*/}
                            <Route path="login" element={<Login />} />
                            <Route path="register" element={<Register />} />
                            <Route path="/reset-password" element={<ResetPassword />} />

                            <Route path="/parkering/create-qr" element={<CreateQRCode />} />
                            <Route path="/parkering/qr-scanner" element={<QRScanner />} />
                            <Route path="/parkering/list" element={<QRCodeList />} />

                            <Route path="role-select" element={<PrivateRoute />}>
                                <Route index element={<RoleSelect />} />
                            </Route>

                            {/*Skal lige ligges rigtigt når man er done*/}
                            <Route path="/shifts" element={<ShiftsPage />} />


                            {/* Admin routes */}
                            <Route path="Admin" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route index element={<Admin />} />
                                
                            </Route>
                            <Route path="Visa/" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route index element={<VisaPage />} />
                            </Route>
                            <Route path="UserDashboard" element={<PrivateRoute />}>
                                <Route index element={<UserDashboard />} />
                            </Route>

                            
                            <Route path="EventPage/:eventId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>
                            <Route path="TeamDashboard/:eventId" element={<PrivateRoute allowedRoles={["Team"]} />}>
                                <Route index element={<TeamDashboard />} />
                            </Route>

                            <Route path="EventPage/:eventId/Function/:functionsId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>


                            <Route path="EventPage/:eventId/:functionsId" element={<PrivateRoute />}>
                                <Route index element={<EventPage />} />
                            </Route>
                            <Route path="/events/:eventId/shifts/public" element={<AllAvailableShiftListPublic eventId={1} language="da" />} />
                            {/* Team routes */}
                            <Route path="/Team">

                                <Route index element={<EventListPage entry="team" title="Team events" />} />
                                <Route path="Visa/:eventId/:userId" element={<VisaPageFront />} />
                                <Route path="Practice/:eventId/:userId" element={<Practice />} />
                                <Route path="transport/booking/:eventId/:userId" element={<TransportRequestOverview />} />
                                <Route path="Accreditations/:eventId/:userId" element={<TeamPerson />} />
                                {/* HOTEL KOMMER SENERE */}
                                {/* OpretID KOMMER SENERE */}

                            </Route>

                            {/* Media Event List */}
                            <Route path="/media" element={<EventListPage entry="media" title="Media events" />} />

                            {/* Media Dashboard by eventId */}
                            <Route path="/MediaDashboard/:eventId" element={<PrivateRoute allowedRoles={["Media"]} />}>
                                <Route index element={<MediaDashboard />} />
                            </Route>

                            <Route path="Club" element={<PrivateRoute allowedRoles={["Club"]} />}>
                                <Route index element={<ClubDashboard />} />
                            </Route>
                            <Route path="Team2" element={<PrivateRoute />}>
                                <Route index element={<Team2 />} />
                            </Route>
                            <Route path="Transport" element={<Transport />} />
                            <Route path="FormTransportArrivalCreate" element={<FormTransportArrivalCreate />} />
                            <Route path="FormTransportDepartureCreate" element={<FormTransportDepartureCreate />} />
                            <Route path="FormTransportLokalCreate" element={<FormTransportLokalCreate />} />
                            <Route path="Transport_ArrivalListe" element={<Transport_ArrivalListe />} />
                            <Route path="Meeting" element={<Meeting />} />
                            <Route path="/meeting/:eventId/:userId?" element={<Meeting />} />
                            <Route path="Practice" element={<Practice />} />
                            <Route path="/practice/:eventId/:userId?" element={<Practice />} />
          

              
                           



                            <Route path="/EventPage/:eventId" element={<EventPage />} />

                            {/* Event routes */}
                            <Route path="Event/Event" element={<PrivateRoute />}>
                                <Route index element={<AdminEvent />} />
                            </Route>
                            <Route path="EventMenu" element={<PrivateRoute />}> {/* <-- new EventMenuPage */}
                                <Route index element={<EventMenuPage />} />
                            </Route>
                            <Route path="DrinksMenu" element={<PrivateRoute />}> {/* <-- new DrinksMenuPage */}
                                <Route index element={<DrinksMenuPage />} />
                            </Route>
                            <Route path="event/zones" element={<PrivateRoute />}>
                                <Route index element={<ZonesPage />} />
                            </Route>
                            <Route path="Ticket" element={<PrivateRoute allowedRoles={["Admin", "Champ"]} />}>
                                <Route index element={<TicketDashBoard />} />
                            </Route>

                            <Route path="id" element={<PrivateRoute />}>
                                <Route index element={<Persons />} />
                            </Route>

                            {/* Skal finde sig plads når jeg done */}
                            <Route path="/admin/events/files" element={<EventFilesAdminPage />} />
                            <Route path="/events/:eventId/files" element={<EventFilesViewPage />} />
                            <Route path="/admin/transport/settings" element={<TransportAdminPageSettings />} />
                            <Route path="/admin/Experience" element={<ExperienceAdminPage />} />
                            <Route path="/TransportDashboard" element={<TransportDashboard />} />
                            <Route path="/admin/Transport/daily" element={<TransportAdminPageDaily />} />
                            

                            <Route path="iddesigner" element={<PrivateRoute />}>
                                <Route index element={<IDCardDesignerPage />} />
                            </Route>

                            <Route path="gruppebeskeder" element={<PrivateRoute />}>
                                <Route index element={<AdminMessagePage />} />
                            </Route>
                            <Route path="friviligeliste" element={<PrivateRoute />}>
                                <Route index element={<FriviligePage />} />
                            </Route>

                            <Route path="useradmin" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route index element={<UserAdmin />} />
                            </Route>
                            <Route path="admin" element={<PrivateRoute allowedRoles={["Admin"]} />}>
                                <Route path="mediaapplication" element={<MediaAdminPage />} />
                            </Route>



                            {/*<Routes>*/}

                                {/* ===================== */}
                                {/* 🍺 DRINKS – BAR UI */}
                                {/* ===================== */}
                            <Route
                                path="/admin/drinks/order/:eventId/:id"
                                element={<FormDrinkOrder />}
                            />
                            <Route path="/form-drink-order/:eventId/:id" element={<FormDrinkOrder />} />

                                {/* ===================== */}
                                {/* 🔧 DRINKS – ADMIN */}
                                {/* ===================== */}
                                <Route
                                    path="/admin/drinks/group-allowance"
                                element={<AdminDrinkFunctionAllowance />}
                                />

                                <Route
                                    path="/admin/drinks/person-allowance"
                                element={<AdminDrinkPersonAllowance />}
                                />

                                <Route
                                    path="/admin/drinks/overview"
                                    element={<AdminDrinkOverview />}
                                />

                                <Route
                                path="/admin/drinks/assigned"
                                element={<AdminDrinkAssignedPersons />}
                                />

                            <Route path="/admin/drink-ticket-collections" element={<AdminDrinkTicketCollections />} />
                            <Route path="/drink-ticket-order" element={<DrinkTicketOrder />} />
                            <Route path="/admin/drink-ticket-print" element={<AdminDrinkTicketPrint />} />

                            <Route path="/admin/transport/overview/:eventId" element={<AdminTransportBookings />} />
                            <Route path="/admin/MeetingAdmin" element={<MeeetingAdminPage />} />

                            
                            <Route path="/admin/TransportVIP" element={<TransportVIP />} />
                            
                            {/*</Transport Routes>*/} 
                            <Route path="/admin/TransportRouteDashboard" element={<TransportRouteDashboard />} />
                            <Route path="/admin/transport-routes" element={<TransportRouteAdminPage />} />
                            <Route path="/transport-route/book" element={<TransportRouteBookingPage />} />
                            <Route path="/admin/transport-route/bookings" element={<TransportRouteBookingsAdminPage />} />
                            <Route path="/transport/local/:eventId"  element={<TransportLocalRequestPage />} />

                            <Route path="Champ" element={<PrivateRoute allowedRoles={["Champ"]} />}>
                                <Route index element={<ChampDashboard />} />
                            </Route>
{/*                            <Route path="/Practice" element={<Form_Practice />} />*/}
                            </Route>
                            <Route path="/transport/book" element={<TransportBookingPage />} />
                            <Route path="/experience/book" element={<ExperienceBookingPage />} />
                            {/*</Transport>*/}
                            <Route path="/transport/booking/:eventId" element={<TransportRequestOverview />} />
                            <Route path="/transport/booking/:eventId/:userId" element={<TransportRequestOverview />} />
                            <Route path="/transport/departure/:eventId" element={<TransportDepartureRequestPage />} />
                            <Route path="/transport/arrival/:eventId" element={<TransportArrivalRequestPage />} />
                            <Route path="/transport/my-bookings/:eventId" element={<TransportMyBookings />} />
                            <Route path="/admin/whatsapp" element={<WhatsAppAdmin />} />
                        <Route path="/parkering/:eventId/:personId" element={<ParkingValidationPage />} />

                    </Routes>
                </Router>
            </LanguageProvider>
        </MantineProvider>
    );
};

export default App;